export interface RegionalCommitteeInstitutionSearch {
  regionalCommitteeId: number;
  countyId: number;
  name?: string;
  dateFrom: Date;
  dateTo: Date;

  municipalityIds?: number[];
  townIds?: number[];
}

export enum RegionalCommitteeInstitutionSort {
  Code = 1,
  Town = 2,
  InstitutionName = 3,
}
